import { useEffect, useState, useRef } from "react";
import api from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Bell, CalendarCheck } from "lucide-react";
import { toast } from "sonner";

export default function NotificationBell({ suffix = "" }) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const prev = useRef(0);
  const first = useRef(true);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items);
      setUnread(data.unread);
      if (!first.current && data.unread > prev.current) {
        toast.info(data.items[0]?.message || "Nuova prenotazione");
      }
      prev.current = data.unread;
      first.current = false;
    } catch {}
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);

  const markRead = async () => {
    if (unread === 0) return;
    try { await api.post("/notifications/read-all"); } catch {}
    setUnread(0);
    prev.current = 0;
    setItems((it) => it.map((i) => ({ ...i, read: true })));
  };

  return (
    <Popover onOpenChange={(o) => { if (o) markRead(); }}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid={`notification-bell${suffix}`}>
          <Bell className="w-5 h-5" />
          {unread > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-medium flex items-center justify-center" data-testid={`notification-badge${suffix}`}>
              {unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid={`notification-panel${suffix}`}>
        <div className="p-3 border-b border-border font-medium text-sm">Notifiche</div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 && <p className="p-4 text-sm text-muted-foreground">Nessuna notifica</p>}
          {items.map((n) => (
            <div key={n.id} className={`p-3 border-b border-border/60 flex gap-2 text-sm ${!n.read ? "bg-secondary/50" : ""}`} data-testid={`notification-${n.id}`}>
              <CalendarCheck className="w-4 h-4 text-primary mt-0.5 shrink-0" />
              <div>
                <p>{n.message}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{new Date(n.created_at).toLocaleString("it-IT")}</p>
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
